import { Card } from '@/components/ui/card';
import type { FormattedStats } from '../../lib/types';

interface ServiceStatsProps {
  stats: Partial<FormattedStats>;
}

export function ServiceStats({ stats }: ServiceStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card className="p-4">
        <div className="text-sm text-muted-foreground">Total Received</div>
        <div className="text-2xl font-semibold text-green-600">{stats.totalReceived}</div>
      </Card>

      <Card className="p-4">
        <div className="text-sm text-muted-foreground">Total Released</div>
        <div className="text-2xl font-semibold text-blue-600">{stats.totalReleased}</div>
      </Card>

      <Card className="p-4">
        <div className="text-sm text-muted-foreground">Service Partners</div>
        <div className="text-2xl font-semibold">{stats.servicePartners}</div>
      </Card>
    </div>
  );
}
